import { ParseOptions } from 'query-string';
import * as React from 'react';

import { DefaultQueryParams, GenericQueryParams } from './types/QueryParams';
import { useGetQueryParams } from './useGetQueryParams';
import { Options, useModifyQueryParams } from './useModifyQueryParams';

export { ModifyQueryParamsAction as Action } from './useModifyQueryParams';

export const useQueryParams = <QueryParams extends GenericQueryParams = DefaultQueryParams>(): {
    getQueryParams: (options?: ParseOptions) => QueryParams;
    modifyQueryParams: (options: Options<QueryParams>) => void;
} => {
    const getQueryParams = useGetQueryParams<QueryParams>();
    const modifyQueryParams = useModifyQueryParams();

    return React.useMemo(
        () => ({
            getQueryParams,
            modifyQueryParams,
        }),
        [getQueryParams, modifyQueryParams]
    );
};
